import React from "react";
import HeroBackground from "src/images/empire-home-slider-one.jpg";
import { Heading } from "src/components/global/Heading";

interface PageHeaderProps {
  pageTitle: string;
  mainImage?: {
    asset: {
      url: string;
    };
  };
  pageHeaderImage?: {
    asset: {
      url: string;
    };
  };
}

export const PageHeader = ({
  pageTitle,
  mainImage,
  pageHeaderImage,
}: PageHeaderProps) => {
  return (
    <section
      id="page-header"
      className="w-full py-24 md:py-0 md:h-[450px] bg-cover bg-center relative z-5 flex justify-center items-center"
      style={{
        backgroundImage: `url(${
          pageHeaderImage?.asset?.url || mainImage?.asset?.url || HeroBackground
        })`,
      }}
    >
      <Heading
        level="h1"
        className="uppercase text-white text-center leading-tight lg:mt-20 z-20"
      >
        {pageTitle}
      </Heading>
      <div className="overlay bg-black w-full h-full opacity-70 absolute z-10"></div>
    </section>
  );
};
